import React from "react";
import RecentPatientsList from "./RecentPatientsList";
import RecentEncountersList from "./RecentEncountersList";
import type { EnrichedAppointment } from "../../utils/schedule";
import type { ScheduleStatus } from "../../hooks/useProviderSchedule";

interface SideColumnProps {
  recentEncounters: EnrichedAppointment[];
  scheduleStatus: ScheduleStatus;
  onSelectPatient: (id: string, encounterId?: string) => void;
}

const SideColumn: React.FC<SideColumnProps> = ({
  recentEncounters,
  scheduleStatus,
  onSelectPatient,
}) => {
  return (
    <div className="flex flex-col gap-6">
      <section
        data-testid="recent-patients"
        className="bg-white p-6 rounded-lg shadow-sm border border-gray-200"
      >
        <h2 className="text-lg font-medium text-gray-900 mb-1">
          Recent Patients
        </h2>
        <p className="text-xs text-gray-500 mb-4">Ordered by last accessed</p>
        <RecentPatientsList onSelectPatient={onSelectPatient} />
      </section>

      <section className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
        <h2 className="text-lg font-medium text-gray-900 mb-1">
          Recent Encounters
        </h2>
        <p className="text-xs text-gray-500 mb-4">Earlier today</p>
        <RecentEncountersList
          encounters={recentEncounters}
          scheduleStatus={scheduleStatus}
          onSelectPatient={onSelectPatient}
        />
      </section>
    </div>
  );
};

export default SideColumn;
